import {createStyles, makeStyles, Theme} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1300,
      display: 'flex',
      flexDirection: 'column',
      whiteSpace: 'pre-wrap',
      gap: 40,
      '& .Warning': {
        borderTop: '1px solid',
        borderTopColor: '#bdbdbd',
        color: '#bdbdbd',
      },
    },
    frameReport: {
      padding: '40px 60px 0 60px',
      background: '#fff',
    },
    p_brainScore: {
      display: 'flex',
      gap: 30,

      '& .Brain-score-table': {
        flex: 6,
        '& table': {width: '100%', borderSpacing: 0, marginBottom: 7},
        '& thead': {
          backgroundColor: Colors.primary,
          color: Colors.white,
          borderColor: Colors.primary,
          padding: 5,
        },
        '& tbody tr td': {
          borderBottom: `1px solid ${Colors.border}`,
          paddingTop: 5,
          paddingBottom: 5,
        },
        '& .AreaLabel': {
          fontSize: 17,
          fontWeight: 'bold',
          color: Colors.darkblue,
        },
        '& .alignMiddle': {
          verticalAlign: 'middle',
        },
        '& .Score': {
          fontSize: 16,
          fontWeight: 'bold',
          color: Colors.darkblue,
        },
        '& .Label': {
          width: '100%',
          textAlign: 'center',
          paddingTop: 3,
          paddingBottom: 3,
          borderRadius: 15,
          fontWeight: 'bold',

          '&.OverActive': {
            backgroundColor: Colors.roi.overActive,
            color: Colors.white,
          },
          '&.Balanced': {
            backgroundColor: Colors.roi.balanced,
            color: Colors.white,
          },
          '&.Underactive': {
            backgroundColor: Colors.roi.underActive,
            color: Colors.white,
            padding: 3,
          },
        },
        '& .Comment': {
          letterSpacing: -1,
          color: Colors.comment,
        },
      },
      '& .Brain-score-info': {
        flex: 6,
        '& .Title': {
          color: '#404040',
          fontWeight: 'bold',
          fontSize: 18,
          marginBottom: 15,
        },
        '& .Desc': {
          fontSize: 16,
          whiteSpace: 'pre-wrap',
        },
      },
    },
    p_brain3D: {
      display: 'flex',
      gap: 20,

      '& .Brain-3d-image': {
        flex: 6,
        '& img': {
          width: '100%',
          height: 'auto',
        },
      },
      '& .Brain-3d-info': {
        flex: 6,
        '& .Title': {
          color: '#404040',
          fontWeight: 'bold',
          fontSize: 18,
          marginBottom: 15,
        },
        '& .Desc': {
          fontSize: 16,
          whiteSpace: 'pre-wrap',
        },
      },
    },

    fiveMajorIndicators: {
      marginBottom: 68,
      width: 1280,
      padding: '40px 60px 80px 60px',
      background: '#fff',
      '@media print': {
        marginBottom: 0,
        paddingBottom: 0,
      },
    },
    imageChart: {
      width: 500,
      '& img': {
        width: 500,
        height: 'auto',
        objectFit: 'contain',
      },
    },
    textChart: {
      display: 'flex',
      alignItems: 'center',
      paddingBottom: 20,
    },
    textWeight: {
      fontWeight: 700,
    },
    textThroughAI: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '120%',
      letterSpacing: '-0.48px !important',
      marginBottom: 6,
    },
    textResultsOfPersonal: {
      fontWeight: 700,
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '-0.03em',
    },
    padding: {
      padding: theme.spacing(1),
    },
    notificationChildContent: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '148%',
      letterSpacing: '-0.54px !important',
    },
    imageDescription: {},
    list: {
      width: 606,
      border: '1px solid #e0e0e0',
      padding: '20px 20px 20px 40px',
      listStyle: 'disc',
      backgroundColor: '#FAFAFA',
      '& li': {
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '26.64px',
        letterSpacing: '-0.04em',
        '&::marker': {
          color: '#444',
        },
      },
    },
    textList: {
      color: '#444',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '148%',
      letterSpacing: '-0.72px !important',
    },
    pullUpContent: {},
    paddingLeft40: {
      marginLeft: 40,
    },
    hrvError: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
      background: '#FAFAFA',
      minHeight: 200,
      width: '100%',
      fontSize: 18,
      fontWeight: 700,
    },
    brainBasic: {
      width: '100%',
      padding: '40px 60px 80px 60px',
      background: '#fff',
      marginBottom: 68,
    },
    brainConnectivityTitle: {
      color: '#000',
      fontSize: '22px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '120%', // 26.4px
      letterSpacing: '-0.66px',
      marginBottom: 24,
      '& span': {
        color: '#00A29C',
      },
    },
    brainConnectivityDes: {
      marginBottom: 40,
      '& p': {
        color: '#333',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '156%', // 28.08px
        letterSpacing: '-0.54px !important',
      },
      '& p:last-child': {
        marginTop: 16,
      },
      '& p:first-child': {
        marginBottom: 16,
      },
      '& ul': {
        display: 'flex',
        padding: '24px 48px',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '6px',
        alignSelf: 'stretch',
        border: '1px solid #E0E0E0',
        background: '#FAFAFA',
      },
      '& ul li': {
        color: '#333',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '148%', // 26.64px
        letterSpacing: '-0.54px !important',
        listStyleType: 'disc',
      },
    },
    contentCard: {
      padding: '0 15px',
      display: 'flex',
      justifyContent: 'space-between',
      gap: 40,
    },
    cardLeftContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexDirection: 'column',
      gap: 34,
      minWidth: 545,
      paddingBottom: '20px 0',
    },
    cardLeftContentAdditional: {
      position: 'absolute',
      width: '100%',
    },
    cardLeftContentAdditionalV1: {
      paddingBottom: '20px 0',
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: '77px',
    },
    cardLeftImg: {
      minWidth: 320,
      minHeight: 388,
      height: 'auto',
      objectFit: 'contain',
    },
    cardRightContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: 40,
      minWidth: 545,
    },
    percentChangeBar: {
      borderTop: '5px solid #000',
    },
    styleAnalysis: {display: 'flex', flexDirection: 'column'},
    cardRightContentAdditional: {
      minWidth: 550,
      marginTop: '100px',
    },
    textBold: {
      color: '#444',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '156%', // 28.08px
      letterSpacing: '-0.54px !important',
    },
    textBlack: {
      color: '#000',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '156%', // 28.08px
      letterSpacing: '-0.54px !important',
    },
    textP: {
      color: '#444',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '156%', // 28.08px
      letterSpacing: '-0.54px !important',
    },
    connectivityBrain: {
      padding: '20px 24px',
    },
    connectivityAnalysis: {
      display: 'flex',
      padding: '24px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '12px',
      alignSelf: 'stretch',
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '100%',
      '& ul': {
        display: 'flex',
        paddingTop: 30,
        marginTop: 20,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        background: '#FAFAFA',
        borderTop: '1px solid #D4D4D4',
        gap: 16,
        paddingLeft: 30,
        paddingBottom: 8,
      },
      '& ul li': {
        color: '#333',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '148%', // 26.64px
        letterSpacing: '-0.54px !important',
        listStyleType: 'disc',
      },
    },
    brainConnectivityBrainRegionTabs2: {
      position: 'relative',
      height: '640px',
    },
    percentBarCardV3: {
      position: 'relative',
      width: '100%',
      height: '640px',
    },
    brainConnectivityBrainRegionTabs3: {
      position: 'relative',
      height: '520px',
      padding: '0 5px 0 18px',
    },
    percentBarCar: {
      position: 'relative',
      width: '100%',
      height: '545px',
    },
    reportContainer: {
      [theme.breakpoints.up('md')]: {
        width: 768,
      },
      [theme.breakpoints.up('lg')]: {
        width: 1440,
      },
    },
  }),
)

export default useStyles
